import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { getCookie } from 'libraries/cookie'

export const productApi = createApi({
  reducerPath: 'productApi',
  baseQuery: fetchBaseQuery({
    baseUrl: window.config.API_URL,
    prepareHeaders: headers => {
      const storeId = window.config.STORE_ID?.toString() || '';
      if (storeId) {
        headers.set('X-BSTORE-ID', storeId);
      }
      const token = getCookie('token')
      if (token) {
        headers.set('Authorization', `Bearer ${token}`)
      }

      return headers
    },
  }),
  endpoints: builder => ({
    fetchProductsListWithParams: builder.query<any, { customerId: any; categoryId: any }>({
      query: ({ customerId, categoryId }) => `/suppliers/v1/products/${customerId}/list?category_id=${categoryId}`,
    }),
    getProductDetail: builder.query<any, any>({
      query: productId => `/suppliers/v1/products/${productId}/product-detail`,
    }),
    fetchSupplierProductsList: builder.mutation<any, any>({
      query: (body) => ({
        url: `/suppliers/v1/products/${body.customer_id}/list`,
        method: 'POST',
        body,
      }),
    }),
  }),
})

export const { useFetchProductsListWithParamsQuery, useGetProductDetailQuery, useFetchSupplierProductsListMutation } = productApi